import React from 'react'
import CityIcon from '../../../../../images/city.svg'
import CountyIcon from '../../../../../images/county.svg'
import SVGIcon from '../../../../../../common/components/svgIcon'
import { IconWrapper, StyledIconTooltip } from './styles'

const PosterJurisdictionIcon = (props) => {
  const file = (props.type === 'city') ? CityIcon : CountyIcon
  return (
    <StyledIconTooltip title={props.title} placement="bottom">
      <IconWrapper>
        <SVGIcon center file={file} />
      </IconWrapper>
    </StyledIconTooltip>
  )
}

export default PosterJurisdictionIcon
